import { isAxiosError } from "axios";
import { api } from "../../api";
import type { EntityType } from "../../generated/core-api";

/**
 * LADR-039 re-import precondition (R-S1-1):
 * - First import (no Tier 2 entity record yet) → omit `if_match_source_version`.
 * - Re-import → must equal current `source_metadata.source_version` (else 412).
 *
 * Company-shell bulk create reuses one workload per workspace (no single
 * `companyCode`), so a second CSV upload against the same workload is almost
 * always a re-import.
 */
export async function resolveIfMatchSourceVersion(
  workloadId: string,
  entityType: EntityType
): Promise<string | undefined> {
  try {
    const record = await api.getOnboardingEntityRecord(workloadId, entityType);
    return record.source_metadata?.source_version;
  } catch (error) {
    if (isAxiosError(error) && error.response?.status === 404) {
      return undefined;
    }
    throw error;
  }
}
